import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class NavBarService {
  data: BehaviorSubject<any> = new BehaviorSubject({});

  constructor() { }

  getData() {
    return this.data;
  }

  setData(d) {
    this.data.next(d);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/nav-bar.service.ts